// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".up-contents {\n  padding: 0.104167rem;\n  box-sizing: border-box;\n}", ""]);
// Exports
module.exports = exports;
